module.exports = __webpack_public_path__ + "media/application/images/practitioner-bg-3c7c4da1bece7b7b45841fae2158205c.png";